import script from './script'

const diagnosticLogTable = () => {
    return { script }
}
export default diagnosticLogTable